import { Model } from './model';

export class Agency extends Model {
  _id: string;
  positive_response: string;
  sms_response: string;
  negative_response: string;
  survey_deletions_disabled: boolean;
  name: string;
}



// WEBPACK FOOTER //
// ./src/app/api/resources/agency.ts